import { WORDMARK_ASPECT, WORDMARK_MARKUP, WORDMARK_VIEWBOX } from './wordmark-data';
import { POSES } from '../mascot-scenes';
import { brandName } from '../brand/brand';
import type { MascotPose } from '../mascot-scenes';
export { mascotPose, MASCOT_SCENARIOS } from '../mascot-scenes';
export type { MascotPose, MascotScenario } from '../mascot-scenes';

/**
 * The Dugzi wordmark, from Dugzi Display 0.108 outlines. Always monochrome:
 * near-black on light surfaces, white on dark. Never tinted with the accent.
 */
export function Wordmark({ height = 28, title, className = '' }: { height?: number; title?: string; className?: string }) {
  title ??= brandName();
  return (
    <span className={`dz-wordmark ${className}`} style={{ height, width: Math.round(height * WORDMARK_ASPECT) }}>
      <svg viewBox={WORDMARK_VIEWBOX} role="img" aria-label={title} dangerouslySetInnerHTML={{ __html: WORDMARK_MARKUP }} />
    </span>
  );
}

/** The adult Dugzi. Decorative by default; pass `alt` when it carries meaning. Never shown in serious states. One theme-independent drawing. */
export function Mascot({ pose, width = 160, alt = '', className = '' }: { pose: MascotPose; width?: number; alt?: string; className?: string }) {
  const art = POSES[pose];
  const sizes = `${width}px`;
  return (
    <span className={`dz-mascot ${className}`} style={{ width }} aria-hidden={alt ? undefined : true}>
      <picture>
        <source type="image/avif" srcSet={art.avif} sizes={sizes} />
        <source type="image/webp" srcSet={art.webp} sizes={sizes} />
        <img src={art.src} width={art.width} height={art.height} alt={alt} draggable={false} decoding="async" />
      </picture>
    </span>
  );
}
